import * as yup from "yup";
import { RequiredStringSchema } from "yup/lib/string";

export const startTime = (): RequiredStringSchema<any, any> =>
  yup
    .string()
    .required("Required")
    .matches(
      /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/,
      "Must be a valid time"
    );

export const endTime = ({
  startTimeField = "startTime"
}: { startTimeField?: string } = {}): RequiredStringSchema<any, any> =>
  yup
    .string()
    .required("Required")
    .matches(
      /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/,
      "Must be a valid time"
    )
    .test("is-greater", "Must be after start time", function (value) {
      const { [startTimeField]: startTime } = this.parent;
      return (
        new Date(`2020-01-01T${startTime}Z`) < new Date(`2020-01-01T${value}Z`)
      );
    });
